/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-30 16:15:44
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\activationemail\locales\en-US.ts
 */
export default {
  'page.activationemail.txtone': 'Mailbox activation succeeded',
  'page.activationemail.txtstart': 'Please in',
  'page.activationemail.txttime': '60 minutes',
  'page.activationemail.txtend': 'go to the mailbox to activate',
  'page.activationemail.btnback': 'Return',
  'page.activationemail.gotoemail': 'Please go to the mailbox to activate',
};
